import React, { useState } from 'react'
import './userlogin.scss'

import BoughtTickets from './ProfileContainer/BoughtTickets'
import Giftcard from './ProfileContainer/Giftcard'
import Membership from './ProfileContainer/Membership'
import Newsletter from './ProfileContainer/Newsletter'
import AdminProfile from './ProfileContainer/adminProfile'
import OrderedTickets from './ProfileContainer/OrderedTickets'

const Profile = () => {

    const [pageKey, setPageKey] = React.useState("a");
    const left = document.getElementById('tes')?.getBoundingClientRect().x
    let page;
    switch (pageKey) {
        case 'a':
            page = <OrderedTickets />
            break;
        case 'b':
            page = <BoughtTickets leftMargin={ left } />
            break;
        case 'c':
            page = <Membership />
            break;
        case 'd':
            page = <Giftcard />
            break;
        case 'e':
            page = <Newsletter />
            break;
        case 'f':
            page = <AdminProfile setPageKey={setPageKey} />
            
    }

   
   
  
    return (
        <main>

            <p className='profile'>Din profil</p>

            <div className='ProfileContainer' id='tes'>
                <aside className='menu-container'>
                    <button style={{ borderBottom: pageKey === 'a' ? '3px solid white' : '' }} onClick={() => setPageKey('a')}>Bestilte Billetter</button>
                    <button style={{ borderBottom: pageKey === 'b' ? '3px solid white' : '' }} onClick={() => setPageKey('b')}>Købte Billetter</button>

                    <button style={{ borderBottom: pageKey === 'c' ? '3px solid white' : '' }} onClick={ () => setPageKey('c') }>Medlemsskaber</button>
                    <button style={{ borderBottom: pageKey === 'd' ? '3px solid white' : '' }} onClick={ () => setPageKey('d')}>Gavekort</button>
                    <button style={{ borderBottom: pageKey === 'e' ? '3px solid white' : '' }} onClick={ () => setPageKey('e')}>Nyhedsbrev</button>
                    <button style={{ borderBottom: pageKey === 'f' ? '3px solid white' : '' }} onClick={ () => setPageKey('f')}>Administrér profil</button>

                </aside>
                <section className='profile-description'>
                    {page}
                </section>
            </div>
          
        </main>
    )
}

export default Profile